import React from "react";
import { HiFolder, HiOutlineDotsVertical, HiCalendar, HiOutlineShare, HiOutlineTrash } from "react-icons/hi";
import { motion } from "framer-motion";

const FolderCard = ({ folder, index = 0, onClick, view = "grid", isBig = false, onRename, onShare, onDelete }) => {
  const date = new Date(folder.createdAt).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });

  // Using constant folder color
  const colorClass = "bg-[#FFE9A2]";

  if (view === "list") {
    return (
      <motion.div
        layout
        whileHover={{ backgroundColor: "#f8fafc" }}
        onClick={onClick}
        className="flex items-center justify-between p-3 px-5 bg-white rounded-2xl border border-transparent hover:border-slate-200 hover:shadow-sm transition-all duration-300 cursor-pointer group mb-1.5"
      >
        <div className="flex items-center gap-4 flex-1">
          <div className="w-12 h-12 rounded-[14px] bg-[#FFE9A2] flex items-center justify-center text-amber-900/60 shadow-inner group-hover:text-amber-900 group-hover:scale-105 transition-all duration-300">
            <HiFolder size={24} className="opacity-80" />
          </div>
          <div className="flex flex-col">
            <h4 className="font-bold text-[15px] text-slate-800  group-hover:text-indigo-600 transition-colors">{folder.name}</h4>
            <p className="text-[11px] text-slate-400 font-semibold">{folder.itemCount || 0} items</p>
          </div>
        </div>

        <div className="hidden md:flex flex-1 items-center gap-2 text-[13px] font-medium text-slate-500">
          {date}
        </div>

        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all duration-200">
          <button
            onClick={(e) => { e.stopPropagation(); onShare(folder); }}
            className="p-2 bg-transparent hover:bg-slate-100 rounded-full text-slate-500 hover:text-slate-800 transition-all"
            title="Share"
          >
            <HiOutlineShare size={18} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onRename(folder); }}
            className="p-2 bg-transparent hover:bg-slate-100 rounded-full text-slate-500 hover:text-slate-800 transition-all"
            title="Rename"
          >
            <HiOutlineDotsVertical size={18} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(folder); }}
            className="p-2 bg-transparent hover:bg-red-50 rounded-full text-slate-500 hover:text-red-600 transition-all"
            title="Delete"
          >
            <HiOutlineTrash size={18} />
          </button>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      layout
      whileHover={{ y: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`relative cursor-pointer group flex flex-col items-center w-full ${isBig ? "p-4" : "p-2"}`}
    >
      <div className="relative w-full aspect-[4/3] mb-3">
        {/* Top tab */}
        <div className={`absolute top-0 left-0 w-[40%] h-[20%] ${colorClass} rounded-t-lg transition-colors duration-300`} />
        {/* Folder body */}
        <div className={`absolute top-[18%] left-0 w-full h-[82%] ${colorClass} rounded-b-lg rounded-tr-lg shadow-md p-2 flex flex-col justify-end transition-all duration-300 group-hover:shadow-lg group-hover:brightness-[0.97]`}>

        </div>

        {/* Quick Actions Overlay on Hover */}
        <div className="absolute inset-0 bg-white/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg flex items-center justify-center gap-1.5 sm:gap-2">
          <button
            onClick={(e) => { e.stopPropagation(); onShare(folder); }}
            className="p-1.5 bg-white text-slate-600 hover:text-indigo-600 rounded-full shadow-sm hover:scale-110 transition-transform"
            title="Share"
          >
            <HiOutlineShare size={15} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onRename(folder); }}
            className="p-1.5 bg-white text-slate-600 hover:text-indigo-600 rounded-full shadow-sm hover:scale-110 transition-transform"
            title="Rename"
          >
            <HiOutlineDotsVertical size={15} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(folder); }}
            className="p-1.5 bg-white text-slate-600 hover:text-red-500 rounded-full shadow-sm hover:scale-110 transition-transform"
            title="Delete"
          >
            <HiOutlineTrash size={15} />
          </button>
        </div>
      </div>

      <div className="text-center w-full px-2">
        <h4 className="text-sm font-medium text-slate-700 truncate tracking-tight mb-0.5">
          {folder.name}
        </h4>
        <div className="text-[10px] text-slate-400">
          {date}
        </div>
      </div>



      {isBig && (
        <div className="mt-8 pt-8 border-t border-slate-100 w-full flex justify-between items-center">
          <div className="flex -space-x-2">
            {[1, 2, 3].map(i => (
              <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-slate-200" />
            ))}
          </div>
          <span className="text-[11px] font-black text-indigo-600 bg-indigo-50 px-3 py-1.5 rounded-xl uppercase">
            Shared
          </span>
        </div>
      )}
    </motion.div>
  );
};

export default FolderCard;
